import { render, staticRenderFns } from "./TrainingSEOSettings.vue?vue&type=template&id=1aff02f9&"
import script from "./TrainingSEOSettings.vue?vue&type=script&lang=js&"
export * from "./TrainingSEOSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports